<template lang="pug">
	div
		h3.mb-3 Приглашение

		b-alert.mb-3(:show='alert.error.hideCountDown' fade dismissible variant='danger' @dismissed='alert.error.hideCountDown=0' @dismiss-count-down='countDownChanged($event, "error")')
			h4.alert-heading Error!
			p {{ alert.error.message }}

		b-alert.mb-3(v-if="myParticipant.data.requested_invitation" :show='alert.success.hideCountDown || myParticipant.data.requested_invitation' fade variant='success')
			p {{ alert.success.message }}

		b-button.mb-3(v-else variant='primary' @click="getInvitation") Получить именное приглашение

		div.mb-3.g-between-center(v-if="myParticipant.data.requested_invitation")
			div Статус приглашения
			div.text-success(v-if="myParticipant.data.invitation_sent") отправлено
			div.text-info(v-else) Формируется...
</template>

<script>
	import {mapActions, mapState} from 'vuex';


	export default {
		name: 'i-option',
		data: () => ({
			alert: {
				success: { hideSecs:0, hideCountDown:0, message: 'Ваш запрос на приглашение отправлен!' },
				error: { hideSecs: 5, hideCountDown: 0, message: 'Произошла ошибка!' }
			},
		}),
		computed: {
			...mapState(['myParticipant', 'account']),
			getPPID(){ return parseInt(this.$route.params.id) } ,
		},
		methods: {
			...mapActions(['patchMyParticipant']),
			countDownChanged(hideCountDown, event) {
				this.alert[event].hideCountDown = hideCountDown;
			},
			getInvitation(){
				this.$store.dispatch('patchMyParticipant', { id:this.getPPID, data:{"requested_invitation":true}} )
					.then( () => {
						this.successFormHandler();
					})
					.catch( error => this.errorFormHandler(error) );
			},
			successFormHandler(){ return this.showAlert(this.alert.success.message, 'success') },
			errorFormHandler: error => this.showAlert(error.non_field_errors ? error.non_field_errors[0] : '', 'error'),
			showAlert(message, event) {
				this.alert[event].hideCountDown = this.alert[event].hideSecs;
				this.alert[event].message = message ? message : this.alert[event].message;
			},
		},
	}
</script>

<style>
</style>
